<template>
    <PortalAuth>
        <div class="d-flex align-items-center min-vh-100">
            <CContainer fluid>
                <CRow class="justify-content-center">
                    <CCol lg="4" md="5" sm="9">
                        <CCard class="mb-0">
                            <CCardBody class="p-4">
                                <CForm @submit.prevent="onSubmit" v-if="!activationEmailSent">
                                    <h1 style="text-align:center">Register</h1>
                                    <p class="text-muted" style="text-align:center">Create your account</p>
                                    <CInput
                                        v-model="email"
                                        placeholder="Email"
                                        type="email"
                                        name="email"
                                        required
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilEnvelopeOpen"/>
                                        </template>
                                    </CInput>
                                    <CInput
                                        v-model="password1"
                                        placeholder="Password"
                                        type="password"
                                        autocomplete="off"
                                        required
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilLockLocked"/>
                                        </template>
                                    </CInput>
                                    <CInput
                                        v-model="password2"
                                        v-if="password1"
                                        placeholder="Repeat password"
                                        type="password"
                                        autocomplete="off"
                                        class="mb-3"
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilLockLocked"/>
                                        </template>
                                    </CInput>
                                    <p class="mt-1" style="text-align:center" v-if="password1">
                                        <CInputCheckbox
                                            class="mt-2 float-left policy-checkbox"
                                            custom
                                            style="transform:scale(1.3, 1.3); margin-left: 0.75rem; margin-right: 0.40rem"
                                            :is-valid="policyCheckboxIsValid"
                                            :checked.sync="policyCheckboxFlag"
                                        />
                                        You confirm that you are older than 18 and agree
                                        to
                                        <br>
                                        <CLink :to="{name: 'terms-of-use'}" style="color:#3c4b64;font-weight:600" target="_blank">Terms of Use</CLink><!--
                                        -->{{ ',' }}

                                        <CLink :to="{name: 'privacy-policy'}" style="color:#3c4b64;font-weight:600" target="_blank">Privacy
                                            Policy
                                        </CLink>
                                    </p>
                                    <FormErrors :errors="errors"/>
                                    <CButton class="mt-4" type="submit" color="info" :disabled="this.graphqlLoadingFlag" block>Create Account</CButton>
                                </CForm>
                                <div v-else>
                                    <h1 style="text-align:center">Activate</h1>
                                    <p>{{activationEmailMessage}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    </PortalAuth>
</template>

<script>
    import {
        getRegisterMutation,
        getProcessedAuthResponseErrorsFlat,
        getTrainingSenderUsernameFromNext,
        onSubmitRegisterHandler
    } from '@/scripts/auth-utils'
    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'
    import router from "@/plugins/router";
    import gql from "graphql-tag";
    import {apolloClient} from "@/plugins/apollo";

    export default {
        components: {
            PortalAuth,
            FormErrors,
        },

        data() {
            return {
                policyCheckboxFlag: false,
                policyCheckboxIsValid: null,
                email: '',
                password1: '',
                password2: '',
                errors: [],
                graphqlLoadingFlag: false,
                trainingSenderUsername: getTrainingSenderUsernameFromNext(),
                activationEmailSent: false,
                activationEmailMessage: 'We have sent a link to your email to activate this account.',
            }
        },
        methods: {
            async onSubmit() {
                this.errors = []
                this.policyCheckboxIsValid = null
                if (this.policyCheckboxFlag) {
                    let mutation = getRegisterMutation(this.email.toLowerCase(), this.password1, this.password2, this.trainingSenderUsername, this.$route.params.tag)
                    await onSubmitRegisterHandler(this, mutation,
                        () => this.onSuccessSubmitHandler(),
                        (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors)
                    )
                } else {
                    this.policyCheckboxIsValid = false
                    this.errors = [{ 'fieldName': 'Policy checkbox', 'message': 'You should agree our policy to continue.'}]
                }
            },
            onSuccessSubmitHandler() {
                this.activationEmailSent = true;
            },
            async loadTexts() {
                let query = gql`{ settings { emailActivationSentText } }`,
                    qRes = await apolloClient.query({query}),
                    text = qRes?.data?.settings?.emailActivationSentText;
                if (text) {
                    this.activationEmailMessage = text;
                }
            }
        },
        watch: {
            policyCheckboxFlag() {
                this.policyCheckboxIsValid = null
                this.errors = []
            }
        },
        created() {
            this.loadTexts()
        }
    }
</script>
<style lang="scss">
    .form-group {
        position: relative;

        .invalid-feedback {
            position: absolute;
            margin-top: 0;
            bottom: -13px;
            text-align: left;
        }
    }
</style>
